import { render } from "./edit_profile.html?vue&type=template&id=5cb96f38&scoped=true&external"
import script from "./edit_profile.js?vue&type=script&lang=js&external"
export * from "./edit_profile.js?vue&type=script&lang=js&external"

import "../Profile/profile_theme.css?vue&type=style&index=0&id=5cb96f38&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb96f38"]])

export default __exports__